__turbopack_context__.v({
  "container": "DateRangePicker-module-scss-module__UoCl9G__container",
  "day": "DateRangePicker-module-scss-module__UoCl9G__day",
  "day-disabled": "DateRangePicker-module-scss-module__UoCl9G__day-disabled",
  "day-end-preview": "DateRangePicker-module-scss-module__UoCl9G__day-end-preview",
  "day-hovered": "DateRangePicker-module-scss-module__UoCl9G__day-hovered",
  "day-in-preview": "DateRangePicker-module-scss-module__UoCl9G__day-in-preview",
  "day-number": "DateRangePicker-module-scss-module__UoCl9G__day-number",
  "day-passive": "DateRangePicker-module-scss-module__UoCl9G__day-passive",
  "day-start-preview": "DateRangePicker-module-scss-module__UoCl9G__day-start-preview",
  "day-today": "DateRangePicker-module-scss-module__UoCl9G__day-today",
  "days": "DateRangePicker-module-scss-module__UoCl9G__days",
  "end-edge": "DateRangePicker-module-scss-module__UoCl9G__end-edge",
  "in-range": "DateRangePicker-module-scss-module__UoCl9G__in-range",
  "month": "DateRangePicker-module-scss-module__UoCl9G__month",
  "month-name": "DateRangePicker-module-scss-module__UoCl9G__month-name",
  "months-horizontal": "DateRangePicker-module-scss-module__UoCl9G__months-horizontal",
  "months-vertical": "DateRangePicker-module-scss-module__UoCl9G__months-vertical",
  "start-edge": "DateRangePicker-module-scss-module__UoCl9G__start-edge",
  "week-day": "DateRangePicker-module-scss-module__UoCl9G__week-day",
  "week-days": "DateRangePicker-module-scss-module__UoCl9G__week-days",
  "with-static-ranges": "DateRangePicker-module-scss-module__UoCl9G__with-static-ranges",
});
